import React from 'react';

import classNames from 'classnames';

import { recruitmentSummaryCategories } from '../workforce/assumption/recruitmentStatusCategories';

/**
 * Positions per recruitment category, from the list's `category_counts`, which the server
 * takes without the category filter so every chip keeps its count while one is selected.
 * `interactive` false renders the counts only.
 */
export default function PositionStatusChips({ counts, selected, interactive = true, onSelect }) {
    const chips = [{ value: '', label: $t('All') }, ...recruitmentSummaryCategories()];

    return (
        <div
            className="in-nav horizontal !tw-w-auto !tw-p-0 !tw-bg-transparent !tw-shadow-none !tw-space-x-0 tw-flex tw-flex-wrap tw-items-center tw-gap-1.5"
            role="group"
            aria-label={$t('Filter by status')}
        >
            <span className="tw-text-xs tw-text-charcoal-50">{$t('By status:')}</span>
            {chips.map((chip) => {
                const isSelected = chip.value === selected;

                return (
                    <button
                        key={chip.value || 'all'}
                        type="button"
                        className={classNames('in-nav__item !tw-h-7 !tw-px-3 tw-text-xs', { active: isSelected, inactive: !isSelected })}
                        aria-pressed={isSelected}
                        disabled={!interactive}
                        onClick={() => onSelect(chip.value)}
                    >
                        {chip.label}
                        <span
                            className={classNames('tw-ms-1.5 tw-rounded-[10px] tw-px-[7px] tw-py-px tw-text-[11px] tw-font-semibold', {
                                'tw-bg-white/25 tw-text-white': isSelected,
                                'tw-bg-blue-25 tw-text-blue': !isSelected,
                            })}
                        >
                            {counts?.[chip.value || 'all'] ?? 0}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
